const routerState = require('catalog/libs').AmpersandState;

const HPEServices = require('./hpe.services');
const HPEConstants = require('./hpe.constants');

module.exports = routerState.extend({
    initialize() {
        //Event to update the params
        HPEServices.subscribe(HPEConstants.router.ROUTER_UPDATE_ATTR, this, this.updateCurrentState);

        //Event to reset the params
        HPEServices.subscribe(HPEConstants.router.ROUTER_REMOVE_ATTR, this, this.removeAttributes);
    },
    props: {
        path: 'string',
        order: 'object',
        useQueryParams: 'boolean',
        usePopStateAssign: 'boolean',
        currentState: 'object',
        updateParams: 'object',
        isLocalhost: 'string',
        dynamicPath: 'string'
    },

    derived: {
        serviceURL: {
            deps: ['dynamicPath'],
            fn: function() {
                if (this.useQueryParams) {
                    return window.location.protocol + '//' + window.location.host + this.path + '.q.json?' + this.dynamicPath;
                } else {
                    return window.location.protocol + '//' + window.location.host + this.dynamicPath + '.q.json';
                }
            }
        },
        baseURL: {
            deps: ['dynamicPath'],
            fn: function() {
                if (this.useQueryParams) {
                    return window.location.protocol + '//' + window.location.host + this.path + '.html?' + this.dynamicPath;
                } else {
                    return window.location.protocol + '//' + window.location.host + this.dynamicPath + '.html';
                }
            }
        }
    },

    updatePath() {
        let newPath = this.path;
        const that = this;
        var key;
        var count = 1;
        var currentStateLength = Object.keys(this.currentState).length;

        if ((this.useQueryParams) || (this.isLocalhost === 'true')) {
            newPath = (this.isLocalhost === 'true') ? newPath + '.html?' : '';
            for (key in this.currentState) {
                newPath += key + '=' + this.currentState[key];
                if (count !== currentStateLength) {
                    newPath += '&';
                }
                count++;
            }

            this.dynamicPath = newPath;
        } else {
            for (key in this.currentState) {
                newPath += '.' + key + '-' + this.currentState[key];
            }
            this.dynamicPath = newPath;
        }

        if (that.usePopStateAssign) {
            window.history.pushState({
                currentState: this.currentState,
                serviceURL: this.serviceURL
            }, null, this.baseURL);
        } else {
            window.history.pushState(null, null, this.baseURL);
        }

        //to populate the browser change event when the user uses the browser btns
        window.onpopstate = function(e) {
            if (that.usePopStateAssign) {
                if (e.state) {
                    HPEServices.publish(HPEConstants.router.BROWSER_POP_STATE, e.state.currentState);
                    HPEServices.publish(HPEConstants.router.BROWSER_URL_CHANGE, e.state.serviceURL);
                }
            } else {
                that.publishBrowserUrlChange();
            }
        };

        //to populate the browser change event when the user click on any btn that change the url
        this.publishBrowserUrlChange();
    },

    publishBrowserUrlChange() {
        HPEServices.publish(HPEConstants.router.BROWSER_URL_CHANGE, this.serviceURL);
    },

    updateCurrentState(newDataPath) {
        var that = this;

        for (const index of Object.keys(newDataPath)) {
          var el = newDataPath[index];
          //remove empty keys from object state
          if (!el || el === '') {
            delete that.currentState[index];
          } else {
            that.currentState[index] = el;
          }
        }

        this.updatePath();
    },

    removeAttributes(removeAttr) {
        const that = this;
        for (const index of Object.keys(removeAttr)) {
          that.currentState[index] = 'all';
        }
        this.updatePath();
    }
});
